import dayjs from 'dayjs'

import Head from 'next/head'
import Image from 'next/image'
import { useRouter } from 'next/router'

import { Link, RichText } from 'prismic-reactjs'

import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
} from 'react-share'

import GetStarted from '../../components/GetStarted'
// import RelatedPost from '../../components/RelatedPost'

import { Client } from '../../utils/prismicHelpers'

const InsightsDetailsPage = ({ post }) => {
    const { asPath } = useRouter()

    const url = `${process.env.NEXT_PUBLIC_APP_URL}${asPath}`

    return (
        <>
            <Head>
                <title>{RichText.asText(post.data.meta_title)}</title>
                <meta
                    name="description"
                    content={RichText.asText(post.data.meta_description)}
                />
                <meta
                    property="og:description"
                    content={RichText.asText(post.data.meta_description)}
                />

                <meta property="og:image" content={post.data.main_image.url} />
                <meta
                    name="twitter:title"
                    content={RichText.asText(post.data.meta_title)}
                />
                <meta
                    name="twitter:description"
                    content={RichText.asText(post.data.meta_description)}
                />
                <meta name="twitter:image" content={post.data.main_image.url} />
                <meta
                    name="twitter:image:alt"
                    content={post.data.main_image.url}
                />
                <link
                    rel="canonical"
                    href={Link.url(post.data.canonical_url)}
                />
            </Head>
            <div>
                <div className="pt-6 section">
                    <div className="insights-detail-content">
                        <div className="text-center tablet:px-6">
                            {/* Main Heading */}
                            <h1 className="w-auto mx-auto ipad:max-w-[640px]">
                                {RichText.asText(post.data.title)}
                            </h1>
                            <span className="block mb-6 text-sm text-interface-700 font-regular">
                                {dayjs(post.data.post_date).format(
                                    'MMMM D, YYYY'
                                )}
                            </span>
                            {/* Cover Image */}
                            <div className="cover max-w-[820px] ipad:w-full tablet:h-auto  h-[512px] rounded-xl overflow-hidden relative mx-auto mb-10">
                                <Image
                                    src={post.data.main_image.url}
                                    alt={post.data.main_image.alt}
                                    layout="responsive"
                                    width={
                                        post.data.main_image.dimensions.width
                                    }
                                    height={
                                        post.data.main_image.dimensions.height
                                    }
                                />
                            </div>
                        </div>
                        {/* Container */}
                        <div className="container">
                            {/* Detail Content */}
                            <RichText render={post.data.content} />
                            {/* Social share */}
                            <ul className="social-share">
                                <li>
                                    <FacebookShareButton url={url}>
                                        <Image
                                            src="/svg/facebook.svg"
                                            alt="Facebook"
                                            layout="responsive"
                                            width={42}
                                            height={42}
                                        />
                                    </FacebookShareButton>
                                </li>
                                <li>
                                    <TwitterShareButton url={url}>
                                        <Image
                                            src="/svg/twitter.svg"
                                            alt="Twitter"
                                            layout="responsive"
                                            width={42}
                                            height={42}
                                        />
                                    </TwitterShareButton>
                                </li>
                                <li>
                                    <WhatsappShareButton url={url}>
                                        <Image
                                            src="/svg/whatsapp.svg"
                                            alt="Whatsapp"
                                            layout="responsive"
                                            width={42}
                                            height={42}
                                        />
                                    </WhatsappShareButton>
                                </li>
                                <li>
                                    <LinkedinShareButton url={url}>
                                        <Image
                                            src="/svg/linkedin.svg"
                                            alt="Linkedin"
                                            layout="responsive"
                                            width={42}
                                            height={42}
                                        />
                                    </LinkedinShareButton>
                                </li>
                            </ul>
                        </div>
                        {/* Separator */}
                        <div className="mb-10 separator"></div>
                        {/* Related Post */}
                        {/*
                        <div className="grid grid-cols-2 gap-8 tablet:grid-cols-1 tablet:px-6">
                            {relatedPostItems.map((item) => (
                                <RelatedPost key={item.id} data={item} />
                            ))}
                        </div>
                        */}
                    </div>
                </div>
                {/* Get started */}
                <GetStarted blueVariant />
            </div>
        </>
    )
}

InsightsDetailsPage.getInitialProps = async ({ query }) => {
    const post = await Client().getByUID('posts', query.uid)

    if (!post) {
        return {
            notFound: true,
        }
    }
    return {
        post,
    }
}

export default InsightsDetailsPage
